var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"disabled":_vm.disabled},on:{"click":function($event){!_vm.disabled && _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v("Continue")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }